(function($, undefined) {
	
	'use strict';
	var setLanguageCookie = function(language) {
        const days = 30; // The number of days the cookie will be valid
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Set the expiration date
        const expires = "expires=" + date.toUTCString();
        document.cookie = "USERLANG=" + language + ";" + expires + ";path=/";
    }
    var getLanguageCookie = function() {
        const name = "USERLANG=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(';');
        
        for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i].trim();
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
          }
        }
        return null; // Return null if the cookie is not found
    }
    var setItemWithExpiry = function(key, value, expiryInMinutes) {
        const now = new Date();
        const expiryTime = now.getTime() + expiryInMinutes * 60 * 1000;
        
        const item = {
          value: value,
          expiry: expiryTime
        };
        
        localStorage.setItem(key, JSON.stringify(item));
    }      
    var getItemWithExpiry = function(key) {
        const itemStr = localStorage.getItem(key);
        
        // If the item doesn't exist, return null
        if (!itemStr) {
          return null;
        }
        
        const item = JSON.parse(itemStr);
        const now = new Date();
        
        // Compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
          // If the item is expired, remove it from storage and return null
          localStorage.removeItem(key);
          return null;
        }
        
        return item.value;
    }
      
      
    
	var init = function () {
        
        // User Language
        var preferredLang = getItemWithExpiry('language');
        if (!preferredLang) {
            var userLang = navigator.language || navigator.userLanguage; 
            userLang = userLang.split('-')[0]; // Extract the language code (e.g., 'en' from 'en-US')
            
            const currentPath = window.location.pathname; // Get the current URL path
            var redirectPath = '';
            var redirectURL = '';
            
            if (!currentPath.startsWith('/en/')) { // Check if the path includes '/en/' slug
                if (userLang=='en') {
                    redirectPath = $(".site-lang-btn").attr("href");
                    // redirectURL = window.location.protocol + '//' + window.location.host + redirectPath + window.location.search + window.location.hash;
                    redirectURL = window.location.protocol + '//' + window.location.host + redirectPath;
                    console.log(redirectURL);
                    window.location.href = redirectURL;
                }
            } else {
                if (userLang=='fr') {
                    redirectPath = $(".site-lang-btn").attr("href");
                    redirectURL = window.location.protocol + '//' + window.location.host + redirectPath;
                    console.log(redirectURL);
                    window.location.href = redirectURL;
                }
            }
        }

        // Click event for language change
        $(".site-lang-btn").click(function(e){
            e.preventDefault();
            let selectedLang = $(this).data("lang");
            setItemWithExpiry('language', selectedLang, 30 * 24 * 60); // 30 days
            redirectPath = $(this).attr("href");
            redirectURL = window.location.protocol + '//' + window.location.host + redirectPath;
            window.location.href = redirectURL;
        });

	};
	
	
	init();
	
})(jQuery);
